import isElectronFn from 'is-electron';

import { get } from 'services/local-storage-service';

export const isDev = () => {
    return window.location.hostname === 'localhost' ||
           window.location.hostname.indexOf('.ngrok.io') > -1 ||
           window.location.hostname.indexOf('nifty.loc') > -1 ||
           /^192\.168/.test(window.location.hostname);
};

export const isMac = () => navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const isMobile = false;

export const isElectron = () => window.ipcRenderer || window.isElectron || (isElectronFn() && !('Cypress' in window));

export const getEnv = () => process.env.REACT_APP_ENV || 'development';

export const debugLogEnabled = () => Boolean(isDev() || get('dev-logs'));
